module.exports = __webpack_public_path__ + "static/media/roulette4.2f9b211e.png";